"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var lodash_1 = require("lodash");
var validators_1 = require("utils/form/validators");
var general_1 = require("utils/general");
var CheckboxNoLabel_1 = __importDefault(require("./CheckboxNoLabel"));
var constants_1 = require("./constants");
var StyledLabel = (0, material_1.styled)('label', {
    shouldForwardProp: (0, general_1.omitProps)('strikethrough', 'size', 'labelColor', 'toggleLabel', 'gap'),
})(function (_a) {
    var theme = _a.theme, strikethrough = _a.strikethrough, _b = _a.size, size = _b === void 0 ? 'medium' : _b, labelColor = _a.labelColor, toggleLabel = _a.toggleLabel, gap = _a.gap;
    return (__assign(__assign(__assign({ margin: 0, display: 'inline-flex', alignItems: 'start', verticalAlign: 'text-top', fontSize: constants_1.SIZE_MAPPER[size].fontSize, lineHeight: constants_1.SIZE_MAPPER[size].lineHeight, gap: theme.spacing(gap || 2), color: (0, lodash_1.get)(theme.palette, labelColor || '', theme.palette.riverstone) }, strikethrough && {
        '.cbLabel > *:not(.skipStrikethrough)': { textDecoration: 'line-through' },
    }), { cursor: toggleLabel ? 'pointer' : 'default', '.MuiCheckbox-root': {
            top: theme.spacing(size === 'small' ? 0.25 : 0.5),
        } }), toggleLabel && {
        userSelect: 'none',
        '&:focus-visible': __assign(__assign({}, theme.focusVisibleStyles), { borderRadius: theme.shape.borderRadius }),
    }));
});
var Checkbox = function (_a) {
    var input = _a.input, label = _a.label, meta = _a.meta, shake = _a.shake, strikethroughIfChecked = _a.strikethroughIfChecked, labelColor = _a.labelColor, toggleLabel = _a.toggleLabel, gap = _a.gap, props = __rest(_a, ["input", "label", "meta", "shake", "strikethroughIfChecked", "labelColor", "toggleLabel", "gap"]);
    var errorToShow = (0, validators_1.getErrorToShow)(meta);
    var value = input.value || !!input.checked;
    var handleClick = function (e) {
        var _a;
        if (!toggleLabel && e.target.type !== 'checkbox' && ((_a = e.target.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'a') {
            e.preventDefault();
        }
    };
    var handleKeyDown = function (e) {
        var _a;
        if (toggleLabel && ((_a = e.target.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'a' && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            input.onChange(!value);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(StyledLabel, __assign({ htmlFor: input.name, strikethrough: strikethroughIfChecked && value, size: props === null || props === void 0 ? void 0 : props.size, labelColor: labelColor, toggleLabel: toggleLabel, tabIndex: toggleLabel ? 0 : -1, onClick: handleClick, onKeyDown: handleKeyDown, gap: gap }, { children: [(0, jsx_runtime_1.jsx)(CheckboxNoLabel_1.default, __assign({}, props, input, { checked: value, id: input.name, tabIndex: toggleLabel ? -1 : 0 })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "cbLabel" }, { children: label }))] })), errorToShow && (0, jsx_runtime_1.jsx)(material_1.FormHelperText, __assign({ error: true, className: shake ? 'shake-animation' : '' }, { children: errorToShow }))] }));
};
exports.default = Checkbox;
